export default "__VITE_ASSET__Crr67fY5__"